import { render, staticRenderFns } from "./IssueVarNewEdit.vue?vue&type=template&id=591f9c68&scoped=true&"
import script from "./IssueVarNewEdit.vue?vue&type=script&lang=js&"
export * from "./IssueVarNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f9c68",
  null
  
)

export default component.exports